import moment from 'moment';

const createDateFromString = (date) => {
  let returnDate = null;

  if (date.length) {
    returnDate = moment(date, 'DD-MM-YYYY');
  }
  return returnDate;
};

const formatDate = (date) => {
  const dateObj = createDateFromString(date);

  // Gets date in format of 09 Dec 2018
  let dateString = '';
  if (dateObj != null) {
    dateString = dateObj.format('DD MMM YYYY');
  }

  return dateString;
};

const getTiFunnelTripDateFormat = (date, locale) => {
  if (!date) return '';
  moment.locale(locale);
  switch (locale) {
    case 'zh-hk':
      return moment(date).format('LL');
    default:
      return moment(date).format('D MMM YYYY');
  }
};

const getProductLastUpdateDateInDisclaimerFormat = (date, locale) => {
  if (!date) return null;
  moment.locale(locale);
  switch (locale) {
    case 'zh-hk':
    case 'zh-tw':
      return moment(date).format('LL');
    default:
      return moment(date).format('D MMM YYYY');
  }
};

const getProductLastUpdateDateFormat = (date, locale) => {
  if (!date) return null;
  moment.locale(locale);
  switch (locale) {
    case 'zh-hk':
    case 'zh-tw':
      return moment(date).format('YYYY年MMM');
    default:
      return moment(date).format('MMM YYYY');
  }
};

const getLastUpdateDateSeoFormat = (date) => {
  if (!date) return null;
  return moment(date).format('YYYY-MM-DD');
};

export {
  formatDate,
  createDateFromString,
  getTiFunnelTripDateFormat,
  getProductLastUpdateDateInDisclaimerFormat,
  getProductLastUpdateDateFormat,
  getLastUpdateDateSeoFormat,
};
